import { ProjectReportField, ProjectReportTemplate } from "@planzone/dto";

function hasType({ type }: ProjectReportField): boolean {
  return type.length > 0;
}

function hasName({ name }: ProjectReportField): boolean {
  return name.length > 0;
}

function trimProjectReportTemplate(
  template: ProjectReportTemplate,
): ProjectReportTemplate {
  return {
    name: template.name,
    indicators: template.indicators.filter(
      (field) => hasType(field) && hasName(field),
    ),
    textFields: template.textFields.filter(
      (field) => hasType(field) && hasName(field),
    ),
  };
}

export { trimProjectReportTemplate };
